<template>
  <div class="viewport-details-panel panel-primary">
    <div class="header-box">
      <div class="title-box">批注详情</div>
      <div
        class="close-icon-box"
        @click="closePanel">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="content-box">
      <div class="item-box">
        <div class="label-box">批注名称：</div>
        <div class="value-box">{{ annotationDetails.name }}</div>
      </div>
      <div class="item-box">
        <div class="label-box">批注类型：</div>
        <div class="value-box muti-line-box">
          {{
            annotationDetails.typeName
              ? annotationDetails.typeName
              : getAnnotationType(annotationDetails)
          }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">严重程度：</div>
        <div class="value-box muti-line-box">
          {{ getAnnotationSeverity(annotationDetails) }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">创建人：</div>
        <div class="value-box">
          {{
            annotationDetails.creatorName ? annotationDetails.creatorName : '--'
          }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">创建时间：</div>
        <div class="value-box">
          {{ formatTime(annotationDetails.creationTime) }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">批注描述：</div>
        <div class="value-box muti-line-box">
          {{
            annotationDetails.description ? annotationDetails.description : '--'
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import { getAnnotationTypeListService } from '@/service/interface'

export default {
  data() {
    return {
      annotationTypeList: []
    }
  },
  props: {
    annotationDetails: Object
  },
  async mounted() {
    this.annotationTypeList = await this.queryAnnotationTypeList()
    let annotationDetails = this.annotationDetails
    let find = this.annotationTypeList.find(
      item => item.typeValue == annotationDetails.annotationType
    )
    this.$set(annotationDetails, 'typeName', find.typeName)
  },
  methods: {
    closePanel() {
      this.$emit('closeAnnotationDetailsPanel')
    },
    getAnnotationType(annotationInfo) {
      let find = this.annotationTypeList.find(
        item => item.typeValue == annotationInfo.annotationType
      )
      return find ? find.typeName : '--'
    },
    getAnnotationSeverity(annotationInfo) {
      const severityTypeList = [
        { typeName: '一般', typeValue: 0 },
        { typeName: '中等', typeValue: 1 },
        { typeName: '严重', typeValue: 2 }
      ]
      let find = severityTypeList.find(
        item => item.typeValue === annotationInfo.severity
      )
      return find ? find.typeName : '--'
    },
    async queryAnnotationTypeList() {
      let projectZoneId = this.$route.params.projId
      let response = await getAnnotationTypeListService({ projectZoneId })
      if (response.isSuccess) {
        let data = response.data
        let annotationTypeList = data.map(item => {
          item.typeName = item.name
          item.typeValue = item.annotationTypeId
          return item
        })
        return annotationTypeList
      } else {
        this.$message.error(response.errMsg)
      }
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
.viewport-details-panel {
  position: absolute;
  left: -50%;
  transform: translate(-50%, 50%);
  margin-left: -10px;
  width: 100%;
  z-index: 3;

  .header-box {
    cursor: default;
  }

  .content-box {
    padding: 16px;
    font-size: 14px;
    color: var(--default-color);

    .item-box {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .label-box {
        width: 80px;
        text-align: right;
        flex-shrink: 0;
      }

      .value-box {
        text-align: left;
      }

      .muti-line-box {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        line-height: 1.5em;
        max-height: 100px;
        overflow-y: auto;
      }
    }
  }
}
</style>
